export abstract class IStepController {
  abstract get isValid(): boolean;
  abstract completeStep(urlParams: string): Promise<void> | void;
}
